module.exports = __webpack_public_path__ + "img/logo-mercado-pago@2x.7b061332.png";